import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { IService, ToastService } from '@irembo-andela/irembogov3-common';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  finalize,
  fromEvent,
  map,
} from 'rxjs';
import { OrganizationsService } from '../../../core/services/public-services/organizations.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'irembogov-searchbox',
  templateUrl: './searchbox.component.html',
  styleUrls: ['./searchbox.component.scss'],
  imports: [TranslateModule],
})
export class SearchboxComponent implements AfterViewInit {
  @ViewChild('search') searchEl: ElementRef | undefined;
  @Input() value = '';
  @Input() placeholder = '';
  @Input() notFoundNavigateUrl = '';
  @Output() resultSelected = new EventEmitter<IService>();
  @Output() keyEnterEvent = new EventEmitter<string>();
  @Output() goAdvanceSearch = new EventEmitter<string>();

  agentGroupIds: string[] = [];

  constructor(
    private servicesService: OrganizationsService,
    private toastService: ToastService
  ) {
    this.getAssignedAgentGroups();
  }

  focused = false;
  keyword = '';
  searchResults: IService[] = [];
  isSearching = false;

  onKeyUp() {
    this.focused = true;
  }

  setFocus(num: number) {
    this.focused = !!num;
  }

  handleSelect(selectedItem: IService) {
    this.value = selectedItem.serviceName;
    this.resultSelected.emit(selectedItem);

    this.searchResults = [];
  }

  ngAfterViewInit(): void {
    fromEvent(this.searchEl?.nativeElement, 'keyup')
      .pipe(
        map((event: unknown) => {
          this.keyword = '';
          if (event instanceof KeyboardEvent) {
            this.keyword = (event.target as HTMLInputElement).value;
          }
          return this.keyword;
        }),
        filter(res => res.length > 2),
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe({
        next: keyword => {
          this.searchByKeyword(keyword);
        },
        error: err => {
          console.log(err);
        },
      });
  }

  onEnter() {
    const inputField = this.searchEl?.nativeElement as HTMLInputElement;
    this.keyEnterEvent.emit(inputField.value);
  }

  goToAdvanceSearch() {
    this.goAdvanceSearch.emit(this.keyword);
  }

  searchByKeyword($event: string) {
    this.isSearching = true;

    this.servicesService
      .getAssignedServices(
        `applicantType=INDIVIDUAL&applicantType=BUSINESS&applicantType=BOTH&query=${$event}`,
        this.agentGroupIds
      )
      .pipe(finalize(() => (this.isSearching = false)))
      .subscribe({
        next: response => {
          this.searchResults = response.data.content;
        },
        error: err => {
          this.toastService.show({
            body: err.error.message,
            type: 'error',
            delay: 5000,
          });
        },
      });
  }

  getAssignedAgentGroups() {
    this.servicesService.getAssignedAgentGroups().subscribe({
      next: agentGroups => {
        this.agentGroupIds = agentGroups.data.agentGroups.map(ag => ag.id);
      },
    });
  }
}
